import { Type } from '@angular/core';
import { ActivationEnd, Event } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { resolveRouteComponentSelector, RouteComponentSelector } from './route-component-selector';

export function routerEventOfType<T extends Event>(type: Type<T>) {
  return (source$: Observable<Event>) => source$.pipe(switchMap(v => (v instanceof type ? of(v) : EMPTY)));
}

export function routerActivationEndForComponent(componentType: Type<unknown> | RouteComponentSelector) {
  const componentSelector = resolveRouteComponentSelector(componentType);
  return (source$: Observable<Event>) =>
    source$.pipe(
      routerEventOfType(ActivationEnd),
      filter(evt => componentSelector(evt.snapshot))
    );
}
